<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div  class="vx-col md:w-1/2 mt-2 w-full mb-4">
        <span  class="title-page">Thêm nguồn dữ liệu</span>
      </div>
      <div class="flex flex-wrap items-center">
        <div class="vx-row ml-2 mb-3">
          <vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            class="text-size"
            @click="addClassifySource"
          >
            Tạo mới nguồn
          </vs-button>
        </div>
      </div>

      <ag-grid-vue
        class="ag-theme-material w-100 my-4 ag-grid-table"
        style="height: 55vh"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="rowDatas"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="20"
        :onGridReady="onGridReady"
        :suppressPaginationPanel="true"
        :per-page="0"
      >
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="currentPage"
        :per-page="perPage"
        @change="onChangePage"
      ></vs-pagination>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import CellRendererActions from "./cell-renderer/CellRendererActions.vue"

export default {
  components: {
    AgGridVue,
    CellRendererActions
  },
  data() {
    return {
      gridOptions: {},
      columnDefs: [
        {
          headerName: "ID",
          field: "id",
          width: 150,
        },
        {
          headerName: "Tên nguồn",
          field: "sourceName",
          width: 200,
        },
        {
          headerName:'Nguồn Website',
          field:'source',
          width:200,
          cellRenderer: function(params) {
            return `<a href="${params.value}" target="_blank" rel="noopener">${params.value}</a>`
          }
        },
        {
          headerName:'Nguồn Facebook',
          field:'sourceFacebook',
          width:200,
          cellRenderer: function(params) {
            return `<a href="${params.value}" target="_blank" rel="noopener">${params.value}</a>`
          }
        },
        {
          headerName:'Hành động',
          field:'transactions',
          width:80,
          cellRendererFramework:'CellRendererActions'
        }
      ],
      defaultColDef: {},
      rowDatas: [],
      totalPages: 0,
      maxPageNumbers: 6,
      perPage: 10,
      gridApi: null,
      currentPage: 1,
      components: {
        AgGridVue,
      },
    };
  },
  watch:{
  '$store.state.isUpdateUser'(val) {
      if (val) {
        this.initScreen();
        this.$store.commit('UPDATE_USER_SUCCESS', false);
      }
    },
  },
  methods: {
    onGridReady() {
      if (this.$store.state.windowWidth <= 1024) {
        this.maxPageNumbers = 5;
      } else {
        this.maxPageNumbers = 7;
      }
      if (this.$store.state.windowWidth > 1024) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    addClassifySource: function(){
        this.$router.push('/user/classify-source-details');
    },
    onChangePage: function (event) {
      const payload = {
        pageNumber: event ? parseInt(event) - 1 : 0,
        pageSize:20
      }
      this.getListDomain(payload);
    },
    initScreen(){
      const payload = {
        pageSize:20,
        pageNumber:0
      };
      this.getListDomain(payload);
    },
    getListDomain(payload){
      this.$vs.loading();
      this.$processor.post('classify-source/getAll',payload)
      .then((response)=>{
        const result = response.data;
        this.rowDatas = result.content;
        this.totalPages = parseInt(result.totalPages,10);
        this.$vs.loading.close();
      })
    },
    initScreen(){
      this.onChangePage();
    }
  },
  async created(){
    this.initScreen();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
};
</script>
<style scoped>
.title-page{
  font-size: 2.2rem;
  font-weight: bold;
}
</style>
